import React from 'react';
import SeeMore from '../../../ui/SeeMore';

import {
  BodyText,
  HeaderText,
  Stack,
} from '../../../ui';

export type AboutMeProps = {
  blurb?: string;
  expandable?: boolean;
  centered?: boolean;
  withHeader?: boolean;
};

const AboutMe: React.FCWithChildren<AboutMeProps> = ({
  blurb,
  expandable,
  centered,
  withHeader,
}) => {
  if (!blurb) {
    return null;
  }

  return (
    <Stack space={4} testID="provider-info-about-me-section">
      {withHeader ? (
        <HeaderText level={4}>About Me</HeaderText>
      ) : null}
      {expandable ? (
        <SeeMore centered={centered}>
          {blurb}
        </SeeMore>
      ) : (
        <BodyText textAlign={centered ? 'center' : undefined}>
          {blurb}
        </BodyText>
      )}
    </Stack>
  );
};

export default AboutMe;
